const employeeDisplayPreferences = {
    employeeDisplayPreferences: {
        employeeDisplayOrganizationalPathLength: 0,
    },
};

const employeesArchiveSettings = {
    employeesArchiveSettings: {
        isEmployeesArchiveHidden: false,
        isEmployeesAutoArchiveOnCancelledBidEnabled: false,
        employeesCancelledBidAutoArchiveNumberOfDays: 0,
        isEmployeesAutoArchiveOnSignedOffBidEnabled: false,
        employeesSignedOffBidAutoArchiveNumberOfDays: 0
    },
};

const managersArchiveSettings = {
    managersArchiveSettings: {
        isManagersAutoArchiveOnCancelledBidEnabled: false,
        managersCancelledBidAutoArchiveNumberOfDays: 0,
        isManagersAutoArchiveOnSignedOffBidEnabled: false,
        managersSignedOffBidAutoArchiveNumberOfDays: 0
    },
};

const datasetFieldLabelsOverride = {
    datasetFieldLabelsOverride: {
        fieldLabelOverrides: {},
    },
};

const orgJobPathCostCenterConfig = {
    orgJobPathCostCenterConfig: {
        selectedCostCenters: [],
        delimiter: '/'
    },
};

/** @type {GlobalSetup.GlobalSetupAppData} */
const globalSetupInitialState = {
    isGlobalSetupDataLoaded: false,
    ...employeeDisplayPreferences,
    ...employeesArchiveSettings,
    ...managersArchiveSettings,
    ...datasetFieldLabelsOverride,
    ...orgJobPathCostCenterConfig,
    reset: { ...employeeDisplayPreferences, ...employeesArchiveSettings, ...managersArchiveSettings, ...datasetFieldLabelsOverride, ...orgJobPathCostCenterConfig },
};

export default globalSetupInitialState;
